import React from 'react';
import { TrendingUp, BarChart3, Shield, Target, ArrowRight, LineChart } from 'lucide-react';
import stocksImage from '../../assets/team-happy-businesswomen-working-office-looking-camera_637285-13049.jpg_urq8qz.jpg';

const StocksPage = () => {
  const services = [
    {
      icon: LineChart,
      title: 'Equity Research & Analysis',
      description: 'Our comprehensive equity research provides in-depth analysis of individual stocks, market trends, and company fundamentals to identify high-potential investment opportunities.'
    },
    {
      icon: TrendingUp,
      title: 'Portfolio Construction',
      description: 'We build diversified stock portfolios tailored to your risk tolerance and investment goals, balancing growth and value stocks across various sectors and market capitalizations.'
    },
    {
      icon: BarChart3,
      title: 'Performance Monitoring',
      description: 'Continuous monitoring of your stock investments with real-time analytics and performance tracking to ensure optimal portfolio management and timely adjustments.'
    },
    {
      icon: Target,
      title: 'Stock Selection Strategy',
      description: 'Our systematic approach to stock selection combines fundamental analysis, technical indicators, and market intelligence to identify stocks with strong growth potential.'
    },
    {
      icon: Shield,
      title: 'Risk Management',
      description: 'Implement robust risk management strategies including stop-loss orders, diversification techniques, and position sizing to protect your stock investments.'
    },
    {
      icon: TrendingUp,
      title: 'Growth Opportunities',
      description: 'Identify and capitalize on emerging growth opportunities in various sectors, from technology and healthcare to sustainable energy and emerging markets.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/80 to-navy-800/60"></div>
        <div className="absolute inset-0">
          <img
            src={stocksImage}
            alt="Stock Investment"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold font-serif mb-4">Stocks</h1>
          <p className="text-xl md:text-2xl text-gray-200">
            Home / <span className="text-gold-400">Stocks</span>
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold font-serif text-navy-900 mb-6">
              Stock Investment at <span className="text-gold-600">HULA CAPITAL LIMITED</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
            <div>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Stock investing represents one of the most dynamic and potentially rewarding investment opportunities available. At HULA CAPITAL LIMITED, we provide comprehensive stock investment services that help you navigate the complexities of equity markets and build a robust portfolio of high-quality stocks.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Our expert team combines fundamental analysis, technical research, and market intelligence to identify stocks with strong growth potential while managing risk through diversification and strategic positioning across various sectors and market segments.
              </p>
            </div>
            
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500">
                <img
                  src={stocksImage}
                  alt="Stock Investment Strategy"
                  className="w-full h-96 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-900/50 to-transparent"></div>
              </div>
            </div>
          </div>

          {/* Services Section */}
          <div className="mb-20">
            <div className="text-center mb-16">
              <h3 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4">
                Comprehensive Stock Services
              </h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => {
                const IconComponent = service.icon;
                return (
                  <div key={index} className="group bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100">
                    <div className="inline-flex p-4 bg-gradient-to-r from-gold-500 to-gold-600 rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                      <IconComponent className="h-8 w-8 text-white" />
                    </div>
                    <h4 className="text-xl font-bold text-navy-900 mb-4">
                      {service.title}
                    </h4>
                    <p className="text-gray-600 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-navy-900 to-navy-800 rounded-2xl p-12 text-center text-white">
            <h3 className="text-3xl md:text-4xl font-bold font-serif mb-6">
              Ready to Invest in Stocks?
            </h3>
            <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
              Build a powerful stock portfolio with expert analysis and strategic selection. 
              Capitalize on market opportunities and achieve long-term wealth growth.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="inline-flex items-center justify-center px-8 py-4 bg-gold-500 hover:bg-gold-600 text-white font-bold rounded-full transition-colors duration-300">
                Start Investing
                <ArrowRight className="ml-2 h-5 w-5" />
              </button>
              <button className="inline-flex items-center justify-center px-8 py-4 border-2 border-white text-white hover:bg-white hover:text-navy-900 font-bold rounded-full transition-all duration-300">
                Learn More
                <ArrowRight className="ml-2 h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StocksPage; 